export default __webpack_public_path__ + "static/media/how-it-works-1920px.c195994e.jpg";